import React from 'react';
import { Text, Flex, Box as Wrapper, Link, Divider, Icon } from '@tonic-ui/react';
import styles from './tile-carousel.module.css';
import ExternalLink from '../../external-link/external-link';

interface Tile {
  image: string;
  heading: string;
  description: string;
  linkUrl: string;
  linkText: string;
}

const Tiles = ({
  heading,
  description,
  linkUrl,
  linkText,
  image,
  ...wrapperProps
}: Tile & ReturnType<Wrapper>): JSX.Element => {
  return (
    <Flex
      minHeight="332px"
      color="white:primary"
      backgroundImage={`url(${image})`}
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      padding="45px 30px"
      flexDirection="column"
      margin="0 8px"
      {...wrapperProps}
    >
      <Text fontSize="xl" lineHeight="xl" fontWeight="semibold" paddingBottom="24px">
        {heading}
      </Text>
      <Divider width="80px" height="3px" bg="white:primary" />
      <Wrapper fontSize="md" lineHeight="md" marginTop="24px">
        <Text>{description}</Text>
      </Wrapper>
      <Wrapper marginTop="auto">
        <ExternalLink href={linkUrl} showIcon={false} className={styles.navigation_link}>
          <Text fontSize="md" lineHeight="md" fontWeight="semibold" color="white:primary">
            {linkText}
          </Text>
          <Icon
            icon="arrow-right"
            ml="2x"
            color="white:primary"
            className={styles.animated_arrow_right}
          />
        </ExternalLink>
      </Wrapper>
    </Flex>
  );
};

Tiles.displayName = 'Tiles';

export default Tiles;
